import { defaultPagination } from 'helpers';

export const initialPurchaseOrderItemsPagination = {
  ...defaultPagination,
  pageSize: 99,
};
